import { c as createAsyncThunk, I as ImprovementAction, r as requestJSON, a as createAction, b as request, f as fetchDictionaryRows, d as fetchActivity, u as updateProcessInstance } from './code-bench-B06c9d4S.mjs';
import { M as Methods, D as DocumentQueryType, a as DocumentStatus, I as ImprovementDictionaryProps } from './enums-COCcEg7n.mjs';
import { s as sortByDate, f as format, F as FORMATS } from './date-time-IA6Oj6Ns.mjs';

const improvementSearch = createAction(ImprovementAction.SEARCH);
const getImprovementsForProcessInstance = createAsyncThunk(ImprovementAction.GET, async (processInstance, _thunkAPI)=>{
    const path = `/coding-api/processinstance/${processInstance.serviceLine}/${processInstance.guid.uuid}/documentimprovement/v1`;
    const response = await requestJSON(path, {
        method: Methods.GET
    });
    const improvements = response.sort((a, b)=>sortByDate(a.created_date, b.created_date)).reverse();
    return improvements;
});
const getImprovementChanges = async (dispatch, processInstance)=>{
    const action = await dispatch(getImprovementsForProcessInstance(processInstance));
    dispatch(fetchActivity(processInstance));
    dispatch(updateProcessInstance({
        serviceLine: processInstance.serviceLine,
        guid: processInstance.guid.uuid
    }));
    return action.payload;
};
const addImprovement = createAsyncThunk(ImprovementAction.ADD, async ({ improvementDictionaryRow, processInstance }, { dispatch })=>{
    const path = `/coding-api/processinstance/${processInstance.serviceLine}/${processInstance.guid.uuid}/documentimprovement/v1`;
    const requiresProvider = new Set([
        DocumentQueryType.REQUIRED,
        DocumentQueryType.CODERS_CHOICE
    ]);
    await requestJSON(path, {
        method: Methods.POST,
        body: JSON.stringify([
            {
                code: improvementDictionaryRow[ImprovementDictionaryProps.ERROR_CODE],
                description: improvementDictionaryRow[ImprovementDictionaryProps.DESCRIPTION],
                provider_query: requiresProvider.has(improvementDictionaryRow[ImprovementDictionaryProps.SEND_QUERY]),
                document_status: DocumentStatus.OPEN
            }
        ])
    });
    return getImprovementChanges(dispatch, processInstance);
});
const updateImprovement = createAsyncThunk(ImprovementAction.UPDATE, async ({ documentImprovement, processInstance }, { dispatch })=>{
    const path = `/coding-api/processinstance/${processInstance.serviceLine}/${processInstance.guid.uuid}/documentimprovement/v1`;
    await requestJSON(path, {
        method: Methods.PATCH,
        body: JSON.stringify([
            documentImprovement
        ])
    });
    return getImprovementChanges(dispatch, processInstance);
});
const removeImprovement = createAsyncThunk(ImprovementAction.REMOVE, async ({ documentImprovement, processInstance }, { dispatch })=>{
    const path = `/coding-api/processinstance/${processInstance.serviceLine}/${processInstance.guid.uuid}/documentimprovement/v1?documentImprovementGuid=${documentImprovement === null || documentImprovement === void 0 ? void 0 : documentImprovement.document_improvement_guid}`;
    await request(path, {
        method: Methods.DELETE
    });
    return getImprovementChanges(dispatch, processInstance);
});
const fetchImprovementOptions = createAsyncThunk(ImprovementAction.FETCH_IMPROVEMENT_OPTIONS, async (improvementRequest, _thunkAPI)=>{
    const currentDate = format(new Date(), FORMATS.DATE);
    const searchParams = new URLSearchParams({
        tenantId: improvementRequest.processInstance.healthSystemTenantId.uuid,
        derivedIndicator: 'true',
        effectiveDate: currentDate,
        dictionaryName: 'Documentation Opportunity',
        columnName: 'Key'
    });
    return fetchDictionaryRows(searchParams);
});
const addImprovementProvider = createAsyncThunk(ImprovementAction.ADD_PROVIDER, async ({ documentImprovement, processInstance, improvementProvider }, { dispatch })=>{
    const path = `/coding-api/processinstance/${processInstance.serviceLine}/${processInstance.guid.uuid}/documentimprovement/${documentImprovement.document_improvement_guid}/provider/v1`;
    await requestJSON(path, {
        method: Methods.POST,
        body: JSON.stringify([
            improvementProvider
        ])
    });
    return getImprovementChanges(dispatch, processInstance);
});
const removeImprovementProvider = createAsyncThunk(ImprovementAction.REMOVE_PROVIDER, async ({ documentImprovement, processInstance, improvementProvider }, { dispatch })=>{
    const path = `/coding-api/processinstance/${processInstance.serviceLine}/${processInstance.guid.uuid}/documentimprovement/${documentImprovement.document_improvement_guid}/provider/v1`;
    await request(path, {
        method: Methods.DELETE,
        body: JSON.stringify([
            improvementProvider
        ])
    });
    return getImprovementChanges(dispatch, processInstance);
});
const updateImprovementProvider = createAsyncThunk(ImprovementAction.UPDATE_PROVIDER, async ({ documentImprovement, processInstance, improvementProvider }, { dispatch })=>{
    const path = `/coding-api/processinstance/${processInstance.serviceLine}/${processInstance.guid.uuid}/documentimprovement/${documentImprovement.document_improvement_guid}/provider/v1`;
    await requestJSON(path, {
        method: Methods.PUT,
        body: JSON.stringify([
            improvementProvider
        ])
    });
    return getImprovementChanges(dispatch, processInstance);
});

var improvements_actions = /*#__PURE__*/Object.freeze({
  __proto__: null,
  addImprovement: addImprovement,
  addImprovementProvider: addImprovementProvider,
  fetchImprovementOptions: fetchImprovementOptions,
  getImprovementsForProcessInstance: getImprovementsForProcessInstance,
  improvementSearch: improvementSearch,
  removeImprovement: removeImprovement,
  removeImprovementProvider: removeImprovementProvider,
  updateImprovement: updateImprovement,
  updateImprovementProvider: updateImprovementProvider
});

export { addImprovement as a, improvements_actions as b, fetchImprovementOptions as f, getImprovementsForProcessInstance as g, improvementSearch as i, removeImprovement as r, updateImprovement as u };
//# sourceMappingURL=improvements.actions-BswOHNMA.mjs.map
